<template>
  <div>
    <GenerateReportFBAPageHead
        :showFilter="showFilter"
        :navTabs="navTabs"
        :countFilterParams="countFilterParams"
        @toggleFilter="toggleFilter"
        @filter="$emit('filter')"
        @changeTab="(data) => $emit('changeTab', data)"
        @reload="$emit('reload')"
    />

    <div class="table-filter-wrap">

      <GenerateReportFBAPageFilter
          :showFilter="showFilter"
          :filterGetParams="filterGetParams"
          :navTabs="navTabs"
          @close="closeFilter"
          @changeFilter="data => $emit('changeFilter', data)"
          @resetFilter="$emit('resetFilter')"
      />

      <GenerateReportFBAPageTable
          :countFilterParams="countFilterParams"
          :navTabs="navTabs"
          @showMore="$emit('showMore')"
          @resetFilter="$emit('resetFilter')"
          @reload="$emit('reload')"
      />
    </div>
  </div>
</template>

<script>


  import GenerateReportFBAPageHead from "./GenerateReportFBAPageHead/GenerateReportFBAPageHead";
  import GenerateReportFBAPageFilter from "./GenerateReportFBAPageFilter/GenerateReportFBAPageFilter";
  import GenerateReportFBAPageTable from "./GenerateReportFBAPageTable/GenerateReportFBAPageTable";

  export default {
    name: "GenerateReportFBAPageTableAdmin",

    components: {
      GenerateReportFBAPageHead,
      GenerateReportFBAPageFilter,
      GenerateReportFBAPageTable,
    },

    props: {
      navTabs: Object,
      countFilterParams: Number,
      filterGetParams: Object,
    },

    data(){
      return{
        showFilter: false,
        activeTab: 1,
      }
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },

      changeShopType(index) {
        this.$emit('changeShopType', index)
      },


      changeFilter(data) {
        this.$emit('changeFilter', data)
      },

      changeTab(id) {
        this.activeTab = id
      },
    }
  }
</script>

<style scoped>

</style>
